import React from 'react'
import { cx } from '@emotion/css'
import PropTypes from 'prop-types'
import styles from './styles'

const RadioBoxGroup = ({ input, children, ...props }) => {
  const name = input.name || props.name
  const value = input.value != null ? input.value : props.value
  const handler = input.onChange || props.onChange

  return (
    <div className={cx(styles.wrapper, props.className)}>
      {React.Children.map(children, (child, index) =>
        React.cloneElement(child, {
          id: `${name}-${index}`,
          name,
          checked: child.props.value === value,
          theme: props.theme,
          ...(props.autoFocus && {
            autoFocus: value ? child.props.value === value : index === 0,
          }),
          onChange: handler,
        }),
      )}
    </div>
  )
}

RadioBoxGroup.propTypes = {
  meta: PropTypes.shape({
    touched: PropTypes.bool,
    error: PropTypes.string,
  }),
  input: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    onChange: PropTypes.func,
  }),
  name: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  autoFocus: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['', 'primary', 'secondary', 'success', 'warning', 'error', 'legacy', 'dark', 'tertiary', 'info']),
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
}

RadioBoxGroup.defaultProps = {
  meta: {},
  input: {},
  theme: 'primary',
}

export default RadioBoxGroup
